<template>
    <div class="bg_eef1fa">
        <div class="main">
            <div class="search_over">搜索结果（共{{count}}条）</div>
        </div>

        <div v-if="count <= 0">
            <div class="main no_data">
                暂无搜索结果
            </div>
        </div>
        <div v-else>
            <div class="text_pic">
                <div class="main">
                    <div class="text_pic_top_title flex_space_between align_items_center">
                        <p>图文故事</p>
                        <router-link to="/teximg/index" class="flex_start align_items_center" v-if="datalist.teximg.length > 0">更多<img src="@/assets/images/icon_right.png" /></router-link>
                    </div>
                    <ul class="flex_space_between flex_wrap" v-if="datalist.teximg.length > 0">
                        <li  v-for="(item,index) in datalist.teximg" class="flex_start" @click="goUrl(this,item.id,item.type)">
                            <div class="pic_box">
                                <img :src="item.pic" />
                            </div>
                            <div class="text_box">
                                <h2>{{item.title}}</h2>
                                <p>{{item.intro}}</p>
                                <span class="flex_space_between">
                                    <label>{{item.source}}</label>
                                    <label>{{item.create_time}}</label>
                                <img src="@/assets/images/like.png" v-if="item.is_like == 0" />
                                <img src="@/assets/images/header_red.png" v-else />
                                </span>
                            </div>
                        </li>
                    </ul>
                    <div class="main no_data bg_fff mr_top_20" v-else>
                        暂无搜索结果
                    </div>
                </div>
            </div>

            <div class="video ">
                <div class="web_main">
                    <div class="main bg_fff">
                        <div class="text_pic_top_title flex_space_between align_items_center">
                            <p class="text_333">视频</p>
                            <router-link to="/video/index" class="flex_start align_items_center" v-if="datalist.video.length > 0">更多<img src="@/assets/images/icon_right.png" /></router-link>
                        </div>
                    </div>

                    <div class="main bg_fff">
                        <div class="video_box flex_start overflow_x_auto" v-if="datalist.video.length > 0">
                            <div class="video_list" v-for="(item,index) in datalist.video" @click="goUrl(this,item.id,item.type)">
                                <div class="video_list_img">
                                    <img :src="item.pic" />
                                </div>
                                <h2>{{item.title}}</h2>
                                <p class="flex_start align_items_center flex_wrap">
                                    <span v-for="(val,key) in item.flag">{{val}}</span>
                                </p>
                            </div>
                        </div>
                        <div class="main no_data" v-else>
                            暂无搜索结果
                        </div>
                    </div>
                </div>
            </div>

            <div class="audit">
                <div class="web_main">
                <div class="main">
                    <div class="text_pic_top_title flex_space_between align_items_center">
                        <p>音频</p>
                        <router-link to="/audit/index" class="flex_start align_items_center" v-if="datalist.audit.length > 0">更多<img src="@/assets/images/icon_right.png" /></router-link>
                    </div>

                </div>
                    <div class="main">
                    <div class="audit_box flex_start flex_wrap " v-if="datalist.audit.length > 0">
                        <div class="audit_list" v-for="(item,index) in datalist.audit" @click="goUrl(this,item.id,item.type)">
                            <div class="audit_list_img">
                                <img :src="item.pic" />
                            </div>
                            <h2>{{item.title}}</h2>
                            <p class="flex_start flex_wrap">
                                <span v-for="(val,key) in item.flag">{{val}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="main no_data" v-else>
                        暂无搜索结果
                    </div>
                </div>
                </div>
                <div class="web_main">
                <div class="main mr_top_40">
                    <div class="text_pic_top_title mr_bottom_20 flex_space_between align_items_center">
                        <p>电子书</p>
                        <router-link to="/book/index" class="flex_start align_items_center" v-if="datalist.book.length > 0">更多<img src="@/assets/images/icon_right.png" /></router-link>
                    </div>
                </div>
                <div class="main">
                    <div class="audit_box flex_start flex_wrap" v-if="datalist.book.length > 0">
                        <div class="audit_list" v-for="(item,index) in datalist.book" @click="goUrl(this,item.id,item.type)">
                            <div class="audit_list_img">
                                <img :src="item.pic" />
                            </div>
                            <h2>{{item.title}}</h2>
                            <p class="flex_start flex_wrap">
                                <span v-for="(val,key) in item.flag">{{val}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="main no_data" v-else>
                        暂无搜索结果
                    </div>
                </div>
                </div>

                <div class="web_main">
                    <div class="main mr_top_40">
                        <div class="text_pic_top_title mr_bottom_20 flex_space_between align_items_center">
                            <p>挂图</p>
                            <router-link to="/wall/index" class="flex_start align_items_center" v-if="datalist.wall.length > 0">更多<img src="@/assets/images/icon_right.png" /></router-link>
                        </div>
                    </div>
                    <div class="main">
                        <div class="wall_map flex_start overflow_x_auto" v-if="datalist.wall.length > 0">
                            <div class="wall_map_list wall_map_list_first" v-for="(item,index) in datalist.wall" @click="goUrl(this,item.id,item.type)" v-if="index == 0">
                                <div class="wall_map_img">
                                    <img :src="item.pic" />
                                </div>
                                <h2>{{item.title}}</h2>
                                <p class="flex_start flex_wrap">
                                    <span v-for="(val,key) in item.flag">{{val}}</span>
                                </p>
                            </div>
                            <div class="wall_map_list wall_map_list_second" v-for="(item,index) in datalist.wall" @click="goUrl(this,item.id,item.type)" v-if="index == 1">
                                <div class="wall_map_list_second_img">
                                    <img :src="item.pic" />
                                </div>
                                <h2>{{item.title}}</h2>
                                <p class="flex_start flex_wrap">
                                    <span v-for="(val,key) in item.flag">{{val}}</span>
                                </p>
                            </div>
                            <div class="wall_map_list wall_map_list_third" v-for="(item,index) in datalist.wall" @click="goUrl(this,item.id,item.type)" v-if="index == 2">
                                <div class="wall_map_list_third_img">
                                    <img :src="item.pic" />
                                </div>
                                <h2>{{item.title}}</h2>
                                <p class="flex_start flex_wrap">
                                    <span v-for="(val,key) in item.flag">{{val}}</span>
                                </p>
                            </div>
                        </div>
                        <div class="main no_data" v-else>
                            暂无搜索结果
                        </div>
                    </div>
                </div>

                <div class="web_main">
                    <div class="main mr_top_40">
                        <div class="text_pic_top_title mr_bottom_20 flex_space_between align_items_center">
                            <p>图片</p>
                            <router-link to="/pic/index" class="flex_start align_items_center" v-if="datalist.pic.length > 0">更多<img src="@/assets/images/icon_right.png" /></router-link>
                        </div>
                    </div>
                    <div class="main no_bg flex_start overflow_x_auto" v-if="datalist.pic.length > 0">
                        <div class="img_list" v-for="(item,index) in datalist.pic" @click="goUrl(this,item.id,item.type)">
                            <div class="img_list_img">
                                <img :src="item.pic" />
                            </div>
                            <h2>{{item.title}}</h2>
                            <p class="flex_start flex_wrap">
                                <span v-for="(val,key) in item.flag">{{val}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="main no_data" v-else>
                        暂无搜索结果
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "index.vue",
        data () {
            return {
                search_key : '',
                datalist: [],
                count:0
            }
        },
        created() {
            this.search_key = this.$route.query.search_key;
            this.$http({
                url: 'index/search',
                method: 'post',
                headers: {"Content-Type": "multipart/form-data"},
                data: {search_key:this.search_key,token:localStorage.getItem('user_token')}
            }).then(res => {
                if(res.data.code == 1) {
                    this.datalist = res.data.data.article;
                    this.count = res.data.data.count;
                } else {
                    layer.msg(res.data.msg);
                }
            });
        },
        methods: {
            goUrl: function (obj,id,type) {
                this.$router.push({
                    path: '/' + type + '/detail',
                    query: {
                        id: id
                    }
                })
            },
        },
        mounted(){
        }
    }
</script>
<style scoped>
    .search_over{width: 100%;font-size:30px;color:#666;line-height: 30px;padding-top:55px;}


    .text_pic{width:100%;background: #eef1fa;padding-top:55px;position: relative;}
    .text_pic_top{width: 100%;background: #d9ecff;position: absolute;top:0;left:0;height: 225px;}
    .text_pic_top_title{width:100%;padding-left:40px;position: relative;background:#fff;height: 70px;line-height: 70px;margin-bottom: 20px;position: relative;z-index: 2;}
    .text_pic .text_pic_top_title{margin-bottom: 0;}
    .text_pic_top_title::before{content:"";position: absolute;top:0;left:0;width: 8px;height: 70px;background:#627eb6;}
    .no_before::before{display: none;}
    .text_pic_top_title p{width: auto;font-size:40px;color:#333;display: block;}
    .text_pic_top_title a{width: auto;font-size:20px;color:#333;display: block;padding-right: 20px;}
    .text_pic_top_title a img{height: 20px;object-fit: contain;display: block;width: 20px;margin-left:3px;}
    .text_pic ul {position: relative;z-index:2;margin-top:5px;}
    .text_pic ul li{width: 575px;height: 240px;padding:20px;background:#fff;border-radius: 10px;box-shadow: 0 0 20px rgba(170,176,194,.2);margin-top: 15px;}
    .text_pic ul li img,.pic_box{width: 200px;height: 200px;object-fit: cover;display: block;}
    .text_box{width:315px;display: block;margin-left:20px;}
    .text_box h2{width: 100%;font-size:22px;color:#333;line-height: 28px;font-weight: normal;height: 56px;overflow: hidden;}
    .text_box p{width: 100%;font-size:14px;line-height: 21px;color:#666;display: block;margin:10px 0;height: 100px;overflow: hidden; }
    .text_box span label {margin-right: 40px;display: inline-block;color:#666;font-size:14px;line-height: 14px;}
    .text_box span img{width:auto !important;height: 14px !important;object-fit:contain;display:inline-block;}

    .video{width:100%;display: block;position: relative;}
    .video_bg{width:100%;height: 100%;position: absolute;top:0;right:0;bottom:0;left:0;z-index:1;}
    .video_bg img{width:100%;height: 100%;object-fit: cover;display: block;}
    .video .main{position: relative;z-index:2;/*padding-top:15px;*/}
    .video .text_pic_top_title{background: none;padding-left:19.5px;}
    /*.video .text_pic_top_title p,.video .text_pic_top_title a{color:#fff;}*/
    .video_box{width:100%;padding-top:4vw;}
    .video_list{width:374px;display: block;min-width: 374px;margin-left:19.5px;}
    .video_list a{width: 100%;display: block;}
    .video_list_img{width:374px;height: 374px;border-radius: 10px;overflow: hidden;display: block;}
    .video_list_img img{width:100%;height: 100%;object-fit: cover;display: block;transition: all ease .5s;}
    .video_list:hover .video_list_img img{transform: scale(1.05);}
    .video_list h2{width:100%;padding:35px 15px;font-size: 24px;line-height: 34px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;font-weight: normal;color:#333;}
    .video_list p{width:100%;padding-bottom: 65px;}
    .video_list p span{font-size:21px;line-height: 33px;border: 1px solid #fff;margin-right: 20px;padding:0 18px;border-radius: 10px;width: auto;display: block;margin-bottom: 5px;}
    .video_list p span:nth-child(3n),.video_list p span:first-child{color:#ff6000;border-color: #ff6000;}
    .video_list p span:nth-child(3n + 1){color:#00aeff;border-color: #00aeff;}
    .video_list p span:nth-child(3n + 2){color:#cf19da;border-color: #cf19da;}

    .audit{width:100%;background: #eef1fa;padding-bottom: 115px;}
    .audit .main{background: #fff;}
    .audit_box{width:100%;}
    .audit_list{width: 245px;margin:20px 40px 70px 20px;}
    .audit_list:nth-child(4n){margin-right: 20px;}
    .audit_list a{width: 100%;display: block;}
    .audit_list_img{width:100%;height: 245px;padding:8px;border-radius: 10px;box-shadow: 0 0 20px rgba(235,235,235,.8);overflow: hidden;display: block;}
    .audit_list_img img{width: 100%;height: 100%;object-fit: cover;display: block;transition: all ease .5s;}
    .audit_list:hover .audit_list_img img{transform: scale(1.05);}
    .audit_list h2{width:100%;padding:35px 15px;font-size: 24px;line-height: 34px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;font-weight: normal;color:#333;}
    .audit_list p{width: 100%;}
    .audit_list p span{width: auto;font-size:14px;line-height: 21px;padding:0 10px;color:#000;display: block;border:1px solid #000;border-radius: 16px;margin-right: 16px;margin-bottom: 5px;}

    .wall_map_list_first{width: 395px;padding:18px;display: block;}
    .wall_map_list a{width: 100%;display: block;}
    .wall_map_img,.wall_map_img img{width: 360px;height: 360px;object-fit: cover;display: block;transition: all ease .5s;overflow: hidden;border-radius: 10px;}
    .wall_map_list:hover .wall_map_img img{transform: scale(1.05);}
    .wall_map_list h2{width:100%;padding:35px 15px;font-size: 24px;line-height: 34px;height: 138px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;font-weight: normal;color:#333;}
    .wall_map_list p{width: 100%;padding-bottom: 37px;}
    .wall_map_list p span{width: auto;font-size:20px;line-height: 32px;padding:0 17px;color:#000;display: block;border:1px solid #000;border-radius: 10px;margin-right: 24px;margin-bottom: 5px;}

    .wall_map_list_second,.wall_map_list_second_img{width: 395px;height: 605px;display: block;overflow: hidden;}
    .wall_map_list_third_img,.wall_map_list_third{width: 410px;height: 605px;display: block;overflow: hidden;}
    .wall_map_list_second_img img,.wall_map_list_third_img img{width: 100%;height: 100%;object-fit: cover;display: block;transition: all ease .5s;}
    .wall_map_list:hover .wall_map_list_second_img img, .wall_map_list:hover .wall_map_list_third_img img{transform: scale(1.05);}



    .img_list{width:282px;margin-right: 24px;display: block;background: #fff;padding:18.5px;}
    .img_list:nth-child(4){margin-right: 0;}
    .img_list a{width: 100%;display: block;}
    .img_list_img,.img_list_img img {width: 245px;height: 245px;object-fit: cover;display: block;transition: all ease .5s;overflow: hidden;border-radius: 5px;}
    .img_list:hover .img_list_img img{transform: scale(1.05);}
    .img_list h2{width:100%;padding:35px 15px;font-size: 24px;line-height: 34px;height: 138px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;font-weight: normal;color:#333;}
    .img_list p{width: 100%;padding-bottom: 11.5px;}
    .img_list p span{width: auto;font-size:14px;line-height: 21px;padding:0 10px;color:#000;display: block;border:1px solid #000;border-radius: 16px;margin-right: 16px;margin-bottom: 5px;}


    .padding_left_half{padding-left:19.5px;}
    .pa_top_15{padding-top:15px;}
    .mr_top_70{margin-top:70px;}
    .mr_top_40{margin-top:40px;}
    .mr_bottom_20{margin-bottom: 20px;}
    .no_bg{background: none !important;}

    .wall_map_list_second h2,.wall_map_list_second p{display: none;}

    .mr_top_20{margin-top:20px;}

    .no_data{font-size:20px;line-height: 30px;padding:10px 2% ;color:#333;}

    @media screen and (max-width: 1920px) {

        .web_main{margin:3.2vw auto 0;width:96%;}


        .audit_list{width:50%;margin:3.2vw 0 3.2vw !important;padding:0 3.2vw;}
        .audit_list:nth-child(5),.audit_list:nth-child(6),.audit_list:nth-child(7),.audit_list:nth-child(8){display: none;}
        .audit_list_img{height: 41.53vw;max-height: 490px;}
        .audit_list h2{margin:1.45vw 0 3.629vw;}
        .audit_list p span{border-radius: 5px;margin-right: 1.29vw;}



        .img_list{width: 48%;min-width: 48%;margin-right: 4%;position: relative;padding:2vw;}
        .overflow_x_auto{overflow-x: auto;}
        .overflow_x_auto::-webkit-scrollbar{display: none;}
        .img_list_img, .img_list_img img,
        .wall_map_list_second_img,.wall_map_img,.wall_map_list_second_img img,
        .wall_map_img img,.wall_map_list_second_img img,
        .wall_map_list_third_img img,.wall_map_list_third_img{width: 100%;height: 40vw;max-height: 490px;}

        /*.img_list p, .wall_map_list p{position: absolute;bottom:2%; left:18.5px;}*/
        .img_list p span, .wall_map_list p span{border-radius: 5px;margin-right: 1.29vw;}
        .wall_map_list p{padding:0;}


        .wall_map_list_second h2,.wall_map_list_second p{display: block;}
        .wall_map_list p{bottom:4%;}
        .wall_map_list{width: 48%;min-width: 48%;margin-right: 4%;background: #fff;padding:2vw; position: relative;}
        .wall_map{background: #eef1fa;}
        .wall_map_list_second, .wall_map_list_second_img,.wall_map_list_third_img, .wall_map_list_third{height: auto;}

        .video_list p{padding-bottom: 2vw;}
    }


    @media screen and (max-width: 1240px) {
        .search_over{padding-left:2%;padding-right: 2%;}
        .text_pic{width: 100%;padding:5.6vw 2% 0;}
        .text_pic ul li{width: 100%;}
        .text_box{width: calc(100% - 220px);}

        .web_main{margin:6.4vw auto 0;width:96%;}
        .no_data{font-size:16px;line-height: 20px;padding:10px 2% ;}

        .video_list{width: 30.16vw;min-width: 30.16vw;margin-left:1.57vw;}
        .video_list_img{width: 30.16vw;height: 30.16vw;}
        .video_list h2{margin:1.45vw 0 3.629vw;font-size:20px;line-height: 30px;}
        .video_list p span{border-radius: 5px;margin-right: 1.29vw;font-size: 14px;line-height: 21px;padding: 0 10px;}

        .img_list h2, .wall_map_list_second h2,  .wall_map_list h2,.audit_list h2,.video_list h2{    width: 100%;
            margin: 1.6vw 0;
            font-size: 2.58vw;
            line-height: 3vw;
            height: auto;
            padding: 0;}
        .audit_list p span,.wall_map_list p span,.img_list p span{width: auto;font-size:14px;line-height: 21px;}
    }


    @media screen and (max-width: 750px) {
        .img_list h2,.wall_map_list h2{font-size: 18px;line-height: 24px;}
        .wall_map_list p{flex-wrap: wrap;}
        .wall_map_list p span{font-size:14px;line-height: 21px;margin-bottom: 3px;}
        .web_audit_swiper .web_audit_page_btn{width: 8vw;height: 8vw;}
        .video_list{width: 44%;min-width: 44%;margin-left:4%;}
        .video_list_img{width: 100%;height: 41.53vw;max-height: 490px;}
    }
    @media screen and (max-width: 640px) {
        .text_pic_top_title p{font-size:5.25vw;}
        .text_pic_top_title{margin-bottom: 3.2vw;height: 10.9375vw;line-height: 10.9375vw;padding-left:6.25vw;}
        .text_pic_top_title::before{height: 10.9375vw;}
        .text_pic_top_title a{font-size:3.125vw;}

        .mr_top_20{margin-top:3.2vw;}

        .text_pic ul li{padding:3.125vw;height: auto;}
        .text_pic ul li img, .pic_box{width: 31.25vw;height: 31.25vw;}
        .text_box{width: calc(100% - 31.25vw - 3.125vw);}
        .text_box h2,.text_box p{height: auto;}
        .text_box{position: relative;}
        .text_box p{margin-bottom: 30px;}
        .text_box span{position: absolute;bottom:0;left:0;width: 100%;}
        .text_box span label{white-space: nowrap;margin-right: 0;}

        .img_list h2, .wall_map_list_second h2,  .wall_map_list h2,.audit_list h2,.video_list h2{ margin: 10px 0 1.6vw;
            font-size: 16px;
            line-height: 24px;
            height: 48px;
            padding: 0;}

        .img_list p span,.wall_map_list p span,.audit_list p span{font-size:10px;line-height: 18px;padding:0 5px;}
        .img_list h2,.wall_map_list h2,.audit_list h2{font-size:16px;line-height: 18px;height: 36px;}
    }
    @media screen and (max-width: 500px) {
        .text_box h2{font-size:18px;line-height: 24px;}
        .text_box p{font-size:12px;line-height: 16px;margin-bottom: 20px;}
    }
    @media screen and (max-width: 440px) {
        /*.audit_list{width:100%;}
        .video_list{width: 100%;min-width: 100%;margin-left:0;padding:0 4%;}
        .audit_list_img,.video_list_img{height: 90vw;}
        .web_audit_swiper .audit_list_img{height:80vw;}*/
    }
</style>



// WEBPACK FOOTER //
// src/pages/home/search.vue